import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Link, matchPath, useLocation, useNavigate } from 'react-router-dom';
import useStore from 'src/hooks/useStore';
import mainLogo from 'src/assets/logo.png';
import { PAGE_ROUTE } from 'src/constants/route';
import { useTranslation } from 'react-i18next';
import { i18nKey } from 'src/locales/i18n';
import styles from './header.module.less';
import { Avatar, Popover, Typography } from 'antd';
import { IUserStore } from 'src/store/user';
import logoutIcon from 'src/assets/logout.png';
import accountIcon from 'src/assets/account.png';
import morgtgageIcon from 'src/assets/mortgage.png';
import { IAuthStore } from 'src/store/auth/auth.store';
import { LIST_URL_NOT_REDIRECT } from 'src/constants';
export interface IPropCapHeader {
	showHome?: boolean;
	showMortgage?: boolean;
	showContract?: boolean;
	isShowOnlyLogo?: boolean;
}
const PropCapHeader: FC<IPropCapHeader> = observer(({ showHome, showMortgage, showContract }: IPropCapHeader) => {
	const [clicked, setClicked] = useState(false);
	const [isUrlBlock, setIsUrlBlock] = useState(false);
	const userStore: IUserStore = useStore('userStore');
	const authStore: IAuthStore = useStore('authStore');
	const location = useLocation();

	const [isShowHeaderFullName, setIsShowHeaderFullName] = useState<boolean>(false);

	const [t] = useTranslation();

	// const onChangeLanguage = (value: string) => {
	// 	i18n.changeLanguage(value.toLocaleLowerCase());
	// };

	const navigator = useNavigate();

	useEffect(() => {
		setIsShowHeaderFullName(
			location.pathname.includes('request-form') ||
				location.pathname.includes(PAGE_ROUTE.DASHBOARD + PAGE_ROUTE.DASHBOARD_ACCOUNT) ||
				location.pathname.includes(PAGE_ROUTE.FUNDER_ACCOUNT) ||
				location.pathname.includes(PAGE_ROUTE.BORROWER_ACCOUNT) ||
				location.pathname.includes(PAGE_ROUTE.BORROWER_COMPANY) ||
				location.pathname.includes(PAGE_ROUTE.FUNDER_COMPANY) ||
				location.pathname.includes(PAGE_ROUTE.VIEW_MORTGAGE_DEAL_FORM)
		);

		const isBlock = LIST_URL_NOT_REDIRECT.includes(location.pathname);
		setIsUrlBlock(isBlock);
	}, [location]);

	const onLogoutClick = async () => {
		setClicked(false);
		userStore.updateDashboard(false);
		await authStore.logout();
		navigator(PAGE_ROUTE.LOGIN);
	};
	const onAccountClick = () => {
		setClicked(false);
		navigator(PAGE_ROUTE.DASHBOARD.concat(PAGE_ROUTE.DASHBOARD_ACCOUNT));
	};
	const handleClickChange = (open: boolean) => {
		setClicked(open);
	};

	const navigatorPage = (page: 'Mortgage Deals' | 'Contact Us') => {
		switch (page) {
			case 'Mortgage Deals':
				// navigator(PAGE_ROUTE.MORTGAGE_DEALS);
				navigator(PAGE_ROUTE.COMMING_SOON);
				break;
			case 'Contact Us':
				navigator(PAGE_ROUTE.CONTRACT_US);
				break;
			default:
				break;
		}
	};

	const HeaderMenu = () => {
		return (
			<div className={styles.menuIconContainer}>
				<div className={styles.menuIcon} onClick={onAccountClick}>
					<img src={accountIcon} />
					<div>{t(i18nKey.dashboard.menu.account)}</div>
				</div>
				<div className={`${styles.menuIcon} ${styles.menuIconMenu}`} onClick={() => navigatorPage('Contact Us')}>
					<div>{t(i18nKey.header.contactUs)}</div>
				</div>

				<div className={`${styles.menuIcon} ${styles.menuIconMenu}`} onClick={() => navigatorPage('Mortgage Deals')}>
					<img src={morgtgageIcon} />
					<div>{t(i18nKey.header.mortgageDeals)}</div>
				</div>

				<div className={styles.menuIcon} onClick={onLogoutClick}>
					<img src={logoutIcon} />
					<div>{t(i18nKey.dashboard.menu.logout)}</div>
				</div>
			</div>
		);
	};

	return (
		<div className={styles.headerContainer}>
			<Link to={isUrlBlock ? '' : '/'} className={styles.homeLink}>
				<img src={mainLogo} className="logo" width={62} height={72} />
			</Link>
			{!isShowHeaderFullName && (
				<>
					{showHome && (
						<Link
							to={PAGE_ROUTE.DASHBOARD}
							className={`${styles.headerLink} ${
								matchPath(PAGE_ROUTE.DASHBOARD, location.pathname) ? styles.linkActive : ''
							}`}>
							{t(i18nKey.header.home)}
						</Link>
					)}
					{showMortgage && (
						<Link
							// to={PAGE_ROUTE.MORTGAGE_DEALS}
							to={PAGE_ROUTE.COMMING_SOON}
							className={`${styles.headerLink} ${
								matchPath(PAGE_ROUTE.MORTGAGE_DEALS, location.pathname) ? styles.linkActive : ''
							}`}>
							{t(i18nKey.header.mortgageDeals)}
						</Link>
					)}
					{showContract && (
						<Link
							to={PAGE_ROUTE.CONTRACT_US}
							className={`${styles.headerLink} ${
								matchPath(PAGE_ROUTE.CONTRACT_US, location.pathname) ? styles.linkActive : ''
							}`}>
							{t(i18nKey.header.contactUs)}
						</Link>
					)}
				</>
			)}

			<div className={styles.headerRight}>
				{isShowHeaderFullName ? (
					<Typography.Text className={styles.headerFullName}>{userStore.getFullName}</Typography.Text>
				) : (
					<>
						{/* <Select
							className={styles.languageSelector}
							bordered={false}
							defaultValue={configuration.lang.toUpperCase()}
							onChange={onChangeLanguage}
							options={[
								{
									key: LANGUAGE.EN,
									value: LANGUAGE.EN.toUpperCase()
								},
								{
									key: LANGUAGE.TC,
									value: LANGUAGE.TC.toUpperCase(),
									label: '繁'
								},
								{
									key: LANGUAGE.SC,
									value: LANGUAGE.SC.toUpperCase(),
									label: '简'
								}
							]}
						/> */}
						{userStore.email && (
							<Popover
								title={null}
								trigger="click"
								placement="bottomLeft"
								content={HeaderMenu}
								style={{ width: 50 }}
								open={clicked}
								onOpenChange={handleClickChange}>
								<Avatar
									style={{ backgroundColor: '#0097ad', verticalAlign: 'middle', fontWeight: 700, cursor: 'pointer' }}
									size="large">
									{userStore.avatarName}
								</Avatar>
							</Popover>
						)}
					</>
				)}
			</div>
		</div>
	);
});

export default PropCapHeader;
